import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { makeStyles, Typography, Button } from '@material-ui/core';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'src/context';
import { Upload, message, Button as B } from 'antd';
import { Icon } from '@ant-design/compatible';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Page from 'src/components/Page';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#ffffff',
    borderRadius: '2px',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    width: '50%'
  },
  logo: {
    width: '90px',
    height: '50px',
    marginTop: 150
  },
  introbox: {
    justifyContent: 'center',
    textAlign: 'center',
    alignContent: 'center',
    marginTop: 100,
    width: 'auto'
  },
  error: {
    textAlign: 'left'
  },
  button: {
    textTransform: 'none',
    display: 'block',
    borderRadius: 2,
    height: 50
  },
  inputText: {
    fontSize: 20,
    color: '#181819',
    fontWeight: 900,
    letterSpacing: 2
  },
  boxActive: {
    borderLeft: '1px dotted #f4f4f5',
    borderTop: '1px dotted #f4f4f5',
    paddingLeft: 10,
    height: 10
  },
  box: { paddingLeft: 10 },
  textActive: {
    borderLeft: '2px solid #3f51b5'
  },
  mainBox: {
    marginBottom: 0
  },
  mainBoxActive: {
    marginBottom: 12
  },
  text: {
    fontSize: 15,
    color: '#3e4040'
  },
  mainText: {
    fontSize: 15,
    color: '#3f51b5'
  },
  buttons: {
    marginTop: 10
  }
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: 0
  },
  '& .MuiInputBase-input': {
    borderRadius: 8,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #ced4da',
    fontSize: 16,
    width: '100%',
    height: '12px',
    padding: '10px 12px',
    boxShadow: '0 1.2px 5.68px 0 rgb(0 0 0 / 20%)',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow'
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ['ubuntu'].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: '#a7aecf'
    }
  }
}));

const Vendor = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { token, userDetails } = useAuthState();
  const [error, setError] = useState(false);
  const [eresponse, setEresponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [values, setValues] = React.useState({
    vendorName: null,
    idCardNum: null,
    address: null,
    phone: null
  });

  React.useEffect(() => {
    axios({
      method: 'get',
      url: 'https://api.fapshi.com/vendorInfo/application',
      data: values,
      headers: { 'x-access-token': token }
    }).then(res => {
      setValues(res.data);
    });
  }, []);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = () => {
    axios({
      method: 'post',
      url: 'https://api.fapshi.com/vendorInfo',
      data: values,
      headers: { 'x-access-token': token }
    })
      .then(res => {
        setValues(res.data);
        setIsLoading(false);
        navigate('/app/activate/vendor/confirmation', { replace: 'false' });
      })
      .catch(err => {
        setIsLoading(false);
        setError(true);
        setEresponse(err.response?.data.message);
      });
  };

  const props = {
    name: 'image',
    action: 'https://api.fapshi.com/idUpload/front',
    headers: {
      authorization: 'authorization-text',
      'x-access-token': token
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const propse = {
    name: 'image',
    action: 'https://api.fapshi.com/idUpload/back',
    headers: {
      authorization: 'authorization-text',
      'x-access-token': token
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const cprops = {
    name: 'image',
    action: 'https://api.fapshi.com/idUpload/picture',
    headers: {
      authorization: 'authorization-text',
      'x-access-token': token
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const prop = {
    name: 'file',
    action: 'https://api.fapshi.com/uploadvendor/docs',
    headers: {
      authorization: 'authorization-text',
      'x-access-token': token
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  return (
    <Page title="Account Activation">
      <Box className={classes.root} sx={{ flexGrow: 1 }}>
        <Box className={classes.mainbox}>
          <Typography
            style={{
              color: 'rgb(26 27 37)',
              fontSize: 35,
              fontWeight: 700,
              fontFamily: 'Ubuntu'
            }}
          >
            Activate your account
          </Typography>
          <Typography
            style={{
              color: '#3e4040',
              fontSize: 14,
              textAlign: 'justify',
              fontWeight: 400,
              fontFamily: 'Ubuntu'
            }}
          >
            Hello {userDetails.username}, Your account is pending activation.
            You won't be able to perform certain transactions. Start by
            activating your account in very simple steps.
          </Typography>
        </Box>

        <Typography
          style={{
            color: '#3e4040',
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'Ubuntu',
            marginBottom: 20
          }}
        >
          Business account
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={4} xl={4}>
            <Box className={classes.mainBox}>
              <Box className={classes.box}>
                <Typography className={classes.text} variant="p">
                  Business structure
                </Typography>
              </Box>
            </Box>
            <Box className={classes.mainBoxActive}>
              <Box className={classes.boxActive}>
                <Typography className={classes.mainText} variant="p">
                  Legal fulfilment
                </Typography>
              </Box>
            </Box>
            <Box className={classes.mainBox}>
              <Box className={classes.box}>
                <Typography className={classes.text} variant="p">
                  Account confirmation
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            style={{
              // backgroundColor: 'rgb(247 250 252)',
              borderRadius: 4,
              padding: 25,
              border: '1px solid #e7eaf5'
            }}
            item
            xs={12}
            sm={12}
            lg={6}
            xl={6}
          >
            <Box>
              <Typography
                variant="h3"
                style={{
                  marginTop: -5,
                  color: '#3e4040'
                }}
              >
                Legal fulfilment
              </Typography>
              <br />
              <Typography
                style={{ color: 'gray', textAlign: 'justify' }}
                variant="p"
              >
                Please give us some insights about the legal bindings of your
                business.
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              {error && (
                <Typography
                  variant="p"
                  style={{
                    color: '#eb6558',
                    fontWeight: 500,
                    fontSize: 14
                  }}
                >
                  {eresponse}
                </Typography>
              )}
              <Box>
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-address"
                  style={{
                    marginTop: 7,
                    color: '#3e4040',
                    fontWeight: 400,
                    fontSize: 20
                  }}
                >
                  <Typography variant="p">Full name </Typography>
                </InputLabel>
                <BootstrapInput
                  fullWidth
                  placeholder="Tell us your names"
                  margin="normal"
                  name="vendorName"
                  value={values.vendorName}
                  onChange={handleChange}
                  type="text"
                  id="bootstrap-input-address"
                  required
                  style={{ marginRight: 8 }}
                />
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-address"
                  style={{
                    marginTop: 7,
                    color: '#3e4040',
                    fontWeight: 400,
                    fontSize: 20
                  }}
                >
                  <Typography variant="p">Phone number </Typography>
                </InputLabel>
                <BootstrapInput
                  fullWidth
                  placeholder="Please enter your phone number"
                  margin="normal"
                  type="number"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  id="bootstrap-input-address"
                  required
                  style={{ marginRight: 8 }}
                />
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-address"
                  style={{
                    marginTop: 7,
                    color: '#3e4040',
                    fontWeight: 400,
                    fontSize: 20
                  }}
                >
                  <Typography variant="p">Home address</Typography>
                </InputLabel>
                <BootstrapInput
                  fullWidth
                  placeholder="Provide your address"
                  margin="normal"
                  type="text"
                  name="address"
                  value={values.address}
                  onChange={handleChange}
                  id="bootstrap-input-address"
                  required
                  style={{ marginRight: 8 }}
                />

                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-address"
                  style={{
                    marginTop: 7,
                    color: '#3e4040',
                    fontWeight: 400,
                    fontSize: 20
                  }}
                >
                  <Typography variant="p">Valid NID number</Typography>
                </InputLabel>
                <BootstrapInput
                  fullWidth
                  placeholder="National ID number"
                  margin="normal"
                  type="text"
                  name="idCardNum"
                  value={values.idCardNum}
                  onChange={handleChange}
                  id="bootstrap-input-address"
                  required
                  style={{ marginRight: 8 }}
                />
                <br />
                <Box>
                  <Typography
                    style={{
                      marginTop: 7,
                      color: '#3e4040',
                      fontWeight: 400,
                      fontSize: 15
                    }}
                    variant="p"
                  >
                    National ID
                  </Typography>
                  <br />
                  <small
                    style={{
                      color: '#3e4040',
                      fontWeight: 400,
                      fontSize: 12
                    }}
                  >
                    Upload your Id. Make sure the ID card belongs to you. We
                    will use it for accountability purposes.
                  </small>
                  <br />
                  <br />
                  <Upload {...props}>
                    <B
                      style={{ boxShadow: '0 1.2px 5.68px 0 rgb(0 0 0 / 20%)' }}
                    >
                      <Icon type="upload" /> Upload a picture of the front side
                      of your ID
                    </B>
                  </Upload>
                  <br />
                  <Upload {...propse}>
                    <B
                      style={{ boxShadow: '0 1.2px 5.68px 0 rgb(0 0 0 / 20%)' }}
                    >
                      <Icon type="upload" /> Upload a picture of the back side
                      of your ID
                    </B>
                  </Upload>
                  <br />
                  <Upload {...cprops}>
                    <B
                      style={{ boxShadow: '0 1.2px 5.68px 0 rgb(0 0 0 / 20%)' }}
                    >
                      <Icon type="upload" /> Upload a picture of YOU holding
                      your ID
                    </B>
                  </Upload>
                </Box>
                <br />
                <Box>
                  <Typography
                    style={{
                      marginTop: 7,
                      color: '#3e4040',
                      fontWeight: 400,
                      fontSize: 15
                    }}
                    variant="p"
                  >
                    Company documents (optional)
                  </Typography>
                  <br />
                  <small
                    style={{
                      color: '#3e4040',
                      fontWeight: 400,
                      fontSize: 12
                    }}
                  >
                    Please upload these documents as a single PDF. Vendors who
                    submit these, stand a high chance of getting the
                    verification mark.
                  </small>
                  <br />
                  <br />
                  <Upload {...prop}>
                    <B
                      style={{ boxShadow: '0 1.2px 5.68px 0 rgb(0 0 0 / 20%)' }}
                    >
                      <Icon type="upload" /> Upload company documents
                    </B>
                  </Upload>
                </Box>
                <br />
                <Box
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Button
                    className={classes.buttons}
                    variant="outlined"
                    color="default"
                    startIcon={<ArrowBackIcon>send</ArrowBackIcon>}
                    type="submit"
                    onClick={() =>
                      navigate('/app/activate/vendor', { replace: 'false' })
                    }
                    size="small"
                  >
                    Previous
                  </Button>
                  <Button
                    className={classes.buttons}
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardIcon>send</ArrowForwardIcon>}
                    type="submit"
                    onClick={handleSubmit}
                    size="small"
                  >
                    {isLoading ? <CircularProgress size="14px" /> : 'Confirm'}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
};

export default Vendor;
